import { render, staticRenderFns } from "./CardLong.vue?vue&type=template&id=2e25f3cc&"
import script from "./CardLong.vue?vue&type=script&lang=js&"
export * from "./CardLong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports